<template>
  <div class="container">
    <div class="top">
      <p class="name">
        <span>部门管理</span>
        <span>&nbsp;&nbsp;(共{{total?total:0}}个)</span>
      </p>
      <div class="search-wrap">
        <el-input
          class="search"
          placeholder="搜索部门名称"
          v-model="searchStr"
          @input ="inputChange(searchStr)"
          >
        <i slot="suffix"
          class="el-input__icon el-icon-search"
          @click="querySearch(searchStr)"
        ></i>
        </el-input>
        <el-button type="primary" @click="addCouster">创建部门</el-button>
      </div>
    </div>
    <!-- <div class="tipes" >说明：客户列表中的成员可免费在润泽食堂用餐。</div> -->
    <div>
      <el-table :data="mates"
                align='center'
                style="width: 100%">
        <el-table-column prop="name"
                        align='center'
                        label="部门"
                        >
        </el-table-column>
        <el-table-column prop="count"
                        align='center'
                        label="部门员工"
                        >
        </el-table-column>
        <el-table-column prop="createName"
                        align='center'
                        label="创建者"
                        width="200"
                        >
        </el-table-column>
        <el-table-column prop="createTime"
                        align='center'
                        label="创建时间"
                        >
                        <template slot-scope="scope">
                          {{scope.row.createTime.replace(/\-/g, "/")}}
                        </template>
        </el-table-column>
        <el-table-column
                        align='center'
                        label="操作"
                        >
          <template slot-scope="scope">
            <!-- 直接在click事件上把当前要操作的用户的信息赋值了，省去了在写一个方法，不过这种写法合适不合适需要讨论 -->
            <el-button @click.native.prevent="editClick(scope.row)"
                      type="text">
              修改信息
            </el-button>
            <el-button @click.native.prevent="del(scope.row)"
                      type="text">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :page-size="5"
        align='center'
        @current-change="pageChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      title="添加部门"
      :visible.sync="addVisible"
      align='center'
      width="30%">
      <el-input v-model="employeeName" :maxlength="10" placeholder="请输入部门名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser">确定创建</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改部门信息"
      :visible.sync="editVisible"
      @close='closeDialog'
      align='center'
      width="30%">
      <el-input v-model="oldTagValue"   :maxlength="10" placeholder="请输入部门名称" ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser">确定修改</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="'确定删除部门'"
      :visible.sync="delVisible"
      align='center'
      width="30%">
      <div class="box">
        <span class="font">当前部门员工 {{count}}名，删除后，这些员工 将变为无部门员工 。</span>
      </div>
      <span slot="footer" class="del-footer">
        <el-button @click="delVisible = false">考虑一下</el-button>
        <el-button type="primary" @click="delMate">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script >
import { getDepartmentData, addDepartment, serMatesByDepartment, delDepartment, editDepartment } from '@/api/department'
import bus from '@/utils/bus'
import { validateTel } from '@/utils/validate'
export default {
  data () {
    return {
      tableData: [],
      addVisible: false,
      editVisible: false,
      delVisible: false,
      delVisibles: false,
      input: '',
      mates: [],
      companyId: '',
      searchStr: '',
      currentId: '', // 当前要操作的用户
      employeeName: '',
      phone: '',
      showTip: 1, // 2的时候为第二种情况，提示有员工，可继续添加   3的时候为该手机号码已存在当前组织中，提示语为红色，添加按钮为灰色，不可添加
      tipMsg: '',
      userNumber: '',
      deductionInput: '',
      tipShow: false,
      succ: false,
      deptId: '',
      isDisable: false,
      page: 1,
      pageSize: 5,
      tagValue: '',
      oldTagValue: '',
      addInput: false,
      addText: '',
      status: true,
      total: '',
      count: ''
    }
  },
  props: [],
  components: {
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.getMates(1)
    // window.addEventListener('scroll', this.loadMore,true);
  },
  created () {
  },
  computed: {
    newSearchStr () {
      // this.querySearch(searchStr);
      this.searchStr + ''
      console.log(this.searchStr)
    }
  },
  watch: {
    phone (newValue, oldValue) {
      if (validateTel(newValue)) {
        getMateNameByPhone({ phone: newValue, companyId: localStorage.companyId }).then(res => {
          console.log(res)
          if (res.msg === 'success' && res.data) {
            this.showTip = 2
            this.tipMsg = `该用户注册名称：${res.data}`
          } else if (res.msg != 'success') {
            this.showTip = 3
            this.tipMsg = res.msg
          }
        })
      } else {
        this.showTip = 1
        this.tipMsg = ''
      }
    }
  },
  methods: {
    // 新增部门
    addCouster () {
      this.addVisible = true
    },
    // 删除部门弹窗
    del (obj) {
      console.log(obj)
      this.delVisible = true
      this.deptId = obj.id
      this.currentName = obj.createName
      this.count = obj.count
    },
    // 删除部门
    delMate () {
      let data = {
        companyId: localStorage.companyId,
        deptId: this.deptId
      }
      delDepartment(data).then(res => {
        if (res === '') {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.delVisible = false
          this.getMates(this.page)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 获取部门列表
    getMates (pages) {
      let data = {
        companyId: this.companyId,
        page: pages,
        size: this.pageSize
      }
      getDepartmentData(data).then(res => {
        console.log(res)
        this.mates = res.list
        this.total = res.count
      })
    },
    // 修改部门信息
    editClick (obj) {
      console.log(obj)
      this.currentId = obj.id
      this.oldTagValue = obj.name
      this.editVisible = true
    },
    // 确认修改部门信息
    editUser () {
      if (!this.oldTagValue) {
        this.$message('请输入姓名')
        return
      }
      let data = {
        id: this.currentId,
        name: this.oldTagValue
      }
      editDepartment(data).then(res => {
        this.$message({
          type: 'success',
          message: '编辑成功'
        })
        this.editVisible = false
        this.getMates(this.page)
      })
    },
    // 确认新增部门
    addUser () {
      if (!this.employeeName) {
        this.$message('请输入姓名')
        return
      }
      let data = {
        name: this.employeeName,
        companyId: localStorage.companyId
      }
      addDepartment(data).then(res => {
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.addVisible = false
        this.employeeName = ''
        this.getMates(this.page)
      })
    },
    timeFomatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    statusFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 0:
          str = '未激活'
          break
        case 1:
          str = '正常'
          break
      }
      return str
    },
    idFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 1:
          str = '福利制表人/福利审核人'
          break
        case 2:
          str = '福利审核人'
          break
        case 3:
          str = '福利制表人'
          break
        case 4:
          str = '普通员工'
          break
      }
      return str
    },
    // 搜索部门
    querySearch (queryString) {
      let data = {
        companyId: localStorage.companyId,
        page: 1,
        size: 10,
        keyword: queryString
      }
      console.log(data)
      serMatesByDepartment(data).then(res => {
        console.log(res)
        this.mates = res.list
        this.total = res.count
      })
    },
    inputChange (val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (val) {
        this.timer = setTimeout(() => {
          this.querySearch(val)
        }, 500)
      } else {
        this.querySearch(val)
      }
    },
    // 切换弹窗
    deductionBox () {
      this.delVisible = false
      setTimeout(() => {
        this.delVisibles = true
      }, 500)
    },
    // 关闭弹窗
    handleDialogClose () {
      this.delVisibles = false
      this.succ = false
      setTimeout(() => {
        this.deductionInput = ''
      }, 500)
    },
    pageChange (page) {
      this.page = page
      this.getMates(page)
    }
  }
}
</script>

<style scoped lang="scss">
%row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container{
  .top{
    @extend %row;
    justify-content: space-between;
    // margin-bottom: 20px;
    .name{
      flex-basis: 68%;
    }
    .search-wrap{
      flex:1;
    }
    .search{
      width: 60%;
      margin-right:8%;
    }
  }
  .tipes{
    font-size: 14px;
    color:#AAAAAA;
    margin-bottom: 10px;
  }
}
.tip{
  color:#409EFF;
  cursor:pointer;
}
.error{
  color: lightcoral;
}
.box{
  display: flex;
  justify-content: space-between;
  .font{
    font-size: 14px;
    line-height: 20px;
  }
}
.dialog-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    width:50%;
    color:rgba(2, 167, 240, 1);
    background:#fff;
    border:1px solid rgba(2, 167, 240, 1);
  }
}
.del-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    color:#D9001B;
    background:#fff;
    border:1px solid rgba(217, 0, 27, 1);
  }
}
.confirm{
  text-align: center;
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .font{
      flex-basis:20%;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
    }
    .input{
      flex-basis:65%;
      flex: 1;
    }
    .unit{
      flex-basis:5%;
      text-align: right;
    }
  }
  .prompt{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:20px;
    .text{
      font-size: 14px;
      line-height: 20px;
    }
    .assignment{
      cursor:pointer;
    }
  }
  .tips{
    font-size: 12px;
    line-height: 18px;
    color:#FF5000;
    text-align: left;
    margin-top: 11px;
  }
  .remark{
    font-size: 12px;
    line-height: 18px;
    color:#999999;
    text-align: left;
    margin-top: 20px;
  }
  .hidden{
    display: none;
  }
}
.succ{
  .boxs{
    display: flex;
    justify-content: flex-start;
    .font{
      .color{
        color:#409EFF;
      }
    }
  }
}
::v-deep .el-select {
    display: block;
    position: relative;
}
.select{
  ::v-deep  .el-input--small .el-input__inner{
    width:100%;
    height: 40px;
    line-height: 40px;
  }
}
.addTagText{
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .name{
    display: block;
    font-size: 16px;
    line-height: 40px;
    color: #027DB4;
    cursor: pointer;
  }
  .input{
    height:40px;
    ::v-deep  .el-input__inner{
      height: 34px;
      line-height: 34px;
    }

  }
}
.delIcon{
  width:20px;
  height:20px;
  position: absolute;
  top:30%;
  right:2%;
  z-index: 10;
  display: none;
}
::v-deep  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover .delIcon{
  display: block;
}
</style>
